
    import React from 'react'
    import Base from '@ucheba/ui/components/Icon'
    import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js"
    import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js"

    const symbol = new SpriteSymbol({
  "id": "icon__arrow-left_circle-outline",
  "use": "icon__arrow-left_circle-outline-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon__arrow-left_circle-outline\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\" /><path fill=\"currentColor\" d=\"M12 1.5c5.786 0 10.5 4.714 10.5 10.5S17.786 22.5 12 22.5 1.5 17.786 1.5 12 6.214 1.5 12 1.5zM12 3c-4.98 0-9 4.02-9 9s4.02 9 9 9 9-4.02 9-9-4.02-9-9-9zm-.252 3.75 1.077 1.032-3.292 3.434h7.721v1.5H9.562l3.263 3.409-1.077 1.032-4.998-5.204 4.998-5.203z\" /></g></symbol>"
})
    sprite.add(symbol)

    export default React.memo(function IconArrowLeftCircleOutlineIcon(props) {
      const { className, ...restProps } = props
      return <Base.Icon className={className} id="icon__arrow-left_circle-outline" {...restProps} />
    })
  